import { render, staticRenderFns } from "./DCard.vue?vue&type=template&id=30f15b69&scoped=true"
import script from "./DCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DCard.vue?vue&type=style&index=0&id=30f15b69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f15b69",
  null
  
)

export default component.exports